/**
 * Use `.filter(hasValue)` instead of `.filter(Boolean)` so TypeScript realizes the returned array won't have any undefined values.
 *
 * See https://developer.mozilla.org/en-US/docs/Glossary/Falsy for more info on excluded values.
 *
 * @param value
 */
export const hasValue = (value) => Boolean(value);
/**
 * Use `.filter(removeDuplicates)` to remove duplicates from an array while keeping the typing.
 * @param value
 * @param index
 * @param self
 */
export const removeDuplicates = (value, index, self) => self.indexOf(value) === index;
